import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import Wrapper from '../components/core/Wrapper';
import Button from '../components/core/Button';
import { getPlans } from '../api';
import GlobalLoading from '../components/GlobalLoading';
import { getFormattedPrice } from '../helpers/price';
import styles from './_endUser.module.scss';

export default function PlanSelected() {
  const { status, message, id: planId } = queryString.parse(
    window.location.search
  );
  const [plan, setPlan] = useState<any>();

  useEffect(() => {
    getPlans().then((data) =>
      setPlan(data.data.data?.find((el: any) => el.id === planId))
    );
  }, []);

  return (
    <Wrapper className={styles.wrapper} subHeader={{ title: 'Plan adquirido' }}>
      {!plan && <GlobalLoading show />}
      {status === 'approved' && plan && (
        <div style={{ textAlign: 'center' }}>
          <i className="fonticons fonticons-checked" />
          <h2 className={styles.title}>Plan adquirido!</h2>
          <p className={styles.desc}>
            Has adquirido el plan <b>{plan.name}</b> por un valor de{' '}
            {getFormattedPrice(plan.price)}
          </p>

          <Button
            spanProps={{ className: styles.btn }}
            label="SALIR"
            onClick={() => (window.location.href = '/')}
          />
        </div>
      )}

      {status === 'error' && (
        <div style={{ textAlign: 'center' }}>
          <h2 className={styles.title}>Ocurrió un error</h2>
          <p className={styles.desc}>
            {message && decodeURIComponent(message as string)}
          </p>

          <Button
            spanProps={{ className: styles.btn }}
            label="SALIR"
            onClick={() => (window.location.href = '/')}
          />
        </div>
      )}
    </Wrapper>
  );
}
